//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  data() {
    return {
      esperar: false,
      estruturaUsuarioResources: this.$api.estruturaUsuario(this.$resource),
      estruturasUsuarios: [],
      headers: [
        { text: this.$tc('label.nome', 1), value: 'nom_estrutura_usuario' },
        { text: this.$tc('label.estrutura_pai', 2), value: 'estrutura_usuario_pai' },
        { text: this.$tc('label.estrutura_usuario', 2), value: 'ind_hierarquia' },
        { text: this.$tc('label.unidade_negocio', 2), value: 'ind_extensao' },
        { text: this.$tc('label.representante', 2), value: 'ind_representante' },
        { text: this.$tc('label.rateio', 2), value: 'ind_rateio' },
        { text: this.$tc('label.ativo', 1), value: 'ind_ativo' },
      ],
      pagination: {},
      statusFilter: 'true',
      totalPage: 0,
      search: '',
    };
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar();
      },
      deep: true,
    },
    search() {
      this.pagination.page = 1;
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.filtrar();
      }, 500);
    },
  },
  computed: {
    ...generateComputed('Estrutura', [
      'canEdit',
      'canGet',
      'canSearch',
    ]),
  },
  methods: {
    buscar() {
      const params = {
        nome: this.search,
        numeroPagina: this.pagination.page,
        tamanhoPagina: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0],
      };
      if (this.statusFilter !== '') {
        params.indAtivo = this.statusFilter;
      }

      this.estruturaUsuarioResources.listar(params)
        .then((response) => {
          this.estruturasUsuarios = response.data.resposta;
          this.totalPage = response.data.quantidadeRegistrosPagina;
          this.pararEsperar();
        })
        .catch((err) => {
          this.pararEsperar();
          this.$error(this, err);
        });
    },
    converterBoolean(valor) {
      if (valor) return this.$t('label.sim');
      return this.$t('label.nao');
    },
    edit(row) {
      this.$emit('ESTRUTURAUSUARIOTABELA_EDITAR', row);
    },
    filtrar() {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        this.buscar();
      }, 5E2);
    },
    montarNomes(estruturaUsuarioPai) {
      return estruturaUsuarioPai.map(u => u.nomEstruturaUsuario).join(', ');
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
    handleStatusFilterChange() {
      this.paginationPage = 0;
      this.buscar();
    },
  },
  mounted() {
    this.buscar();
    if (this.canEdit || (!this.canEdit && this.canGet)) {
      this.headers.unshift({ text: '', value: 'acoes', sortable: false, width: '1%', align: 'center' });
    }
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/estrutura-usuario/EstruturaTabela.vue?vue&type=script&lang=js&